import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = typeof window !== 'undefined' ? localStorage.getItem('pricing_countdown_end') : null;
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      if (remaining > 0) return remaining;
    }
    const end = Date.now() + 24 * 60 * 60 * 1000;
    if (typeof window !== 'undefined') localStorage.setItem('pricing_countdown_end', end.toString());
    return 24 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const cuposPercentage = 71;
  return <section className="w-full bg-neutral-950 py-4 md:py-8" data-id="element-153">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-155">
          <div className="text-center mb-3 md:mb-5" data-id="element-156">
            <div className="bg-rose-950/40 border border-rose-900/60 rounded-2xl p-4 md:p-6 max-w-3xl mx-auto" data-id="element-157">
              <h2 className="text-2xl md:text-4xl font-bold text-amber-50 mb-3 md:mb-4" data-id="element-158">
                ⏰ PRECIO DE LANZAMIENTO — OFERTA LIMITADA
              </h2>

              <div className="flex items-center justify-center gap-2 md:gap-4 mb-3 md:mb-4" data-id="element-159">
                {[{
                value: pad(hours),
                label: 'HS'
              }, {
                value: pad(minutes),
                label: 'MIN'
              }, {
                value: pad(seconds),
                label: 'SEG'
              }].map((unit, index) => <Fragment key={unit.label} data-id="element-160">
                    {index > 0 && <span className="text-4xl md:text-7xl font-bold text-rose-400 -mt-4 md:-mt-6" data-id="element-161">
                        :
                      </span>}
                    <div className="flex flex-col items-center" data-id="element-162">
                      <motion.span key={unit.value} initial={{
                    scale: 1.1,
                    opacity: 0.7
                  }} animate={{
                    scale: 1,
                    opacity: 1
                  }} transition={{
                    duration: 0.2
                  }} className="text-5xl md:text-8xl font-bold text-rose-400 tabular-nums leading-none" data-id="element-163">
                        {unit.value}
                      </motion.span>
                      <span className="text-xs md:text-sm text-neutral-400 font-medium mt-1 tracking-widest" data-id="element-164">
                        {unit.label}
                      </span>
                    </div>
                  </Fragment>)}
              </div>

              <div className="flex items-center justify-center gap-2 text-amber-50 mb-3 md:mb-4" data-id="element-165">
                <span className="text-lg md:text-xl" data-id="element-166">⚠️</span>
                <p className="text-sm md:text-base font-semibold" data-id="element-167">
                  Este precio no se va a mantener. Una vez que se agote el
                  período de lanzamiento, el precio sube a $33.980 ARS. No
                  vuelve atrás.
                </p>
              </div>

              <div className="max-w-xl mx-auto" data-id="element-168">
                <div className="flex items-center justify-between mb-1" data-id="element-169">
                  <div className="flex items-center gap-2" data-id="element-170">
                    <span className="w-2 h-2 rounded-full bg-rose-400 animate-pulse" data-id="element-171"></span>
                    <span className="text-sm text-rose-400 font-medium" data-id="element-172">
                      Cupos al precio de lanzamiento
                    </span>
                  </div>
                  <span className="text-sm text-neutral-300 font-bold" data-id="element-173">
                    Quedan pocos
                  </span>
                </div>
                <div className="w-full h-3 bg-neutral-800 rounded-full overflow-hidden" data-id="element-174">
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: `${cuposPercentage}%`
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1.5,
                  ease: 'easeOut'
                }} className="h-full rounded-full" style={{
                  background: 'linear-gradient(90deg, #f43f5e 0%, #fbbf24 70%, #fbbf24 100%)'
                }} data-id="element-175" />
                </div>
                <p className="text-xs text-neutral-400 mt-1 text-right" data-id="element-176">
                  {cuposPercentage}% de los cupos ya tomados
                </p>
              </div>
            </div>
          </div>

          <h3 id="elegi-tu-pack" className="text-2xl md:text-3xl font-bold text-amber-50 text-center mb-3 md:mb-5 scroll-mt-8" data-id="element-177">
            TU ACCESO COMPLETO
          </h3>

          <div className="max-w-2xl mx-auto" data-id="element-178">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="bg-neutral-900 border-2 border-amber-500 rounded-lg p-5 md:p-6 relative shadow-[0_0_30px_rgba(251,191,36,0.15)]" data-id="element-179">
              <h4 className="text-xl font-bold text-amber-50 mb-1" data-id="element-180">
                🕯️ MEGA PACK VELAS COMESTIBLES GOURMET
              </h4>
              <p className="text-amber-400 font-semibold mb-2 text-sm" data-id="element-181">
                6 Tomos + 3 Bonos — Aprendé, creá y vendé desde casa
              </p>
              <p className="text-neutral-300 text-sm mb-3" data-id="element-182">
                Ideal para cualquier persona que quiera emprender con un
                producto diferente, sin experiencia previa
              </p>
              <div className="mb-3" data-id="element-183">
                <div className="flex items-center gap-2 mb-1" data-id="element-184">
                  <span className="text-neutral-500 line-through text-xl font-medium" data-id="element-185">
                    $33.980
                  </span>
                  <span className="bg-rose-600 text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-186">
                    -50% OFF
                  </span>
                </div>
                <div className="flex items-baseline gap-2" data-id="element-187">
                  <span className="text-amber-400 font-bold text-4xl md:text-5xl" data-id="element-188">
                    $16.990
                  </span>
                  <span className="text-neutral-500 text-sm" data-id="element-189">ARS</span>
                </div>
                <p className="text-green-500 font-semibold text-sm mt-1" data-id="element-190">
                  ✅ Ahorrás $16.990 hoy
                </p>
              </div>
              <motion.a href="https://www.recursohub.com/cart/48298368336064:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block w-full bg-gradient-to-r from-amber-400 to-amber-500 hover:from-amber-300 hover:to-amber-400 text-neutral-950 font-bold text-lg px-6 py-3.5 rounded-lg transition-colors shadow-[0_0_30px_rgba(251,191,36,0.25)] text-center" data-id="element-191">
                🔴 → QUIERO MI MEGA PACK AHORA
              </motion.a>
              <div className="mt-2 text-center text-xs text-neutral-400" data-id="element-192">
                ⭐ Pago 100% seguro · Acceso en 5 minutos · Garantía 7 días
                <br data-id="element-193" />
                Mercado Pago · Tarjeta · Transferencia
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}